import WidgetGrid from "@components/widgets/Grid";
import TotalReachWidget from "./partials/widgets/TotalReach";
import { useParams } from "react-router-dom";
import { useFilterParamsV4 } from "@/hooks/useFilterParams";
import { withDefaultDates } from "@/utils";
import { differenceInDays } from "date-fns";
import TotalPRValueWidget from "./partials/widgets/PRValue";
import ReachDriverWidget from "./partials/widgets/ReachDriver";
import ReachOverTimeWidget from "@components/widgets/ReachOverTime";
import ChannelTypesByReachWidget from "./partials/widgets/ChannelTypesByReach";
import TopSourcesWidget from "./partials/widgets/TopSources";
import { useSearchSectionRoutes } from "@/hooks/useSearchSectionRoutes";
import MentionsInsightsReachViewMentionCards from "./partials/MentionCards";

export default function MentionsInsightsReachView() {
  // URL state
  const { orgUuid, uuid } = useParams<{ orgUuid: Uuid; uuid: Uuid }>();
  const [_filters] = useFilterParamsV4();
  const section = useSearchSectionRoutes();

  // Helpers
  const filters = withDefaultDates(_filters);
  const diffInDays = differenceInDays(filters.end_date, filters.start_date);

  return (
    <div className="flex flex-col gap-8">
      <WidgetGrid>
        <TotalReachWidget
          className="col-span-12 @4xl/grid:col-span-4 h-24"
          diffInDays={diffInDays}
          searchUuid={uuid}
          filters={filters}
        />

        <TotalPRValueWidget
          className="col-span-12 @4xl/grid:col-span-4 h-24"
          diffInDays={diffInDays}
          searchUuid={uuid}
          filters={filters}
        />

        <ReachDriverWidget
          className="col-span-12 @4xl/grid:col-span-4 h-24"
          searchUuid={uuid}
          filters={filters}
        />

        <ReachOverTimeWidget
          className="col-span-12 @4xl/grid:col-span-8 h-96"
          dayLink={section.insightsReachPeriod}
          diffInDays={diffInDays}
          searchUuid={uuid}
          filters={filters}
          orgUuid={orgUuid}
          hideTotals
        />

        <ChannelTypesByReachWidget
          className="col-span-12 @4xl/grid:col-span-4 h-96"
          searchUuid={uuid}
          filters={filters}
        />

        <TopSourcesWidget
          className="col-span-12 min-h-150"
          searchUuid={uuid}
          filters={filters}
        />
      </WidgetGrid>

      <MentionsInsightsReachViewMentionCards
        searchUuid={uuid}
        filters={filters}
        orgUuid={orgUuid}
      />
    </div>
  );
}
